/**
 * Legacy service-store presentation adapter.
 *
 * Raw service and organisation collections are not presentation APIs. The
 * release surface obtains allowlisted placements from itemAuthorityService;
 * compatibility callers receive an empty bounded state until their detail flow
 * is migrated.
 */

export default {
  state: {
    services: [],
    service: null,
    loading: false,
    lastVisibleService: null,
    allowedOrgs: [],
  },
  getters: {
    services: (state) => state.services,
    service: (state) => state.service,
    lastVisibleService: (state) => state.lastVisibleService,
  },
  actions: {
    async fetchAllowedOrganisations({ commit }) {
      commit("SET_ALLOWED_ORGANISATIONS", []);
      return [];
    },
    async fetchServices({ commit }, { refresh = false, isInitial = false } = {}) {
      commit("SET_LOADING", true);
      if (refresh) commit("SET_LAST_VISIBLE_SERVICE", null);
      if (refresh || isInitial) commit("SET_SERVICES", []);
      commit("SET_LOADING", false);
      return { items: [], nextCursor: null, hasMore: false };
    },
    async fetchService({ commit }) {
      commit("SET_LOADING", true);
      commit("SET_SERVICE", null);
      commit("SET_LOADING", false);
      return null;
    },
    clearService({ commit }) {
      commit("CLEAR_SERVICE");
    },
  },
  mutations: {
    SET_ALLOWED_ORGANISATIONS(state, allowedOrgs) {
      state.allowedOrgs = allowedOrgs;
    },
    SET_SERVICES(state, services) {
      state.services = services;
    },
    ADD_SERVICES(state, services) {
      state.services = [...state.services, ...services];
    },
    SET_SERVICE(state, service) {
      state.service = service;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_LAST_VISIBLE_SERVICE(state, service) {
      state.lastVisibleService = service;
    },
    CLEAR_SERVICE(state) {
      state.service = null;
    },
  },
};
